/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import * as yup from 'yup'
import { Field } from 'react-trazo-forms/dist/FormField'

import { Values, utils } from 'react-trazo-forms'
import { i18n } from '../../../../providers/Locale/localeProvider'
import {
  communeOptions,
  countryOptions,
  getValue,
  messages,
  dayOptions,
  monthOptions,
  yearOptions
} from '../../helpers/forms'

const GenderOptions = [
  { key: 'Masculino', value: 'Masculino', label: 'Masculino' },
  { key: 'Femenino', value: 'Femenino', label: 'Femenino' },
]

const JobTitleOptions = [
  { key: 'Medico veterinario', value: 'Medico veterinario', label: 'Medico veterinario' },
  { key: 'Administrador de la clínica', value: 'Administrador de la clínica', label: 'Administrador de la clínica' },
  { key: 'Gerente de área', value: 'Gerente de área', label: 'Gerente de área' },
  { key: 'Gerente General', value: 'Gerente General', label: 'Gerente General' },
  { key: 'Dueño o Representante Legal', value: 'Dueño o Representante Legal', label: 'Dueño o Representante Legal' },
]

// Form definitions

export const informationInitialValues = (information?: any, birthDay?: any) => ({
  IsChilean: getValue(information, 'IsChilean', true),
  Country: getValue(information, 'Country', 'Chile'),
  Commune: getValue(information, 'Commune', undefined),
  Passport: getValue(information, 'Passport', undefined),
  RUT: getValue(information, 'RUT', undefined),
  Day: getValue(birthDay, 'Day', undefined),
  Month: getValue(birthDay, 'Month', undefined),
  Year: getValue(birthDay, 'Year', undefined),
  PhoneNumber: getValue(information, 'PhoneNumber', undefined),
  Gender: getValue(information, 'Gender', ''),
  JobTitle: getValue(information, 'JobTitle', undefined),
  CompanyName: getValue(information, 'CompanyName', ''),
  LengthOfService: getValue(information, 'LengthOfService', undefined),
})

export const informationFields = (): Field[] => ([
  {
    name: 'IsChilean',
    placeholder: 'Soy Chileno/a',
    label: '¿Es Chileno/a?',
    type: 'switch',
    extraProps: { leftPlaceholder: 'Soy Extranjero/a' },
  },
  {
    name: 'Country',
    placeholder: 'Por favor, seleccione su país',
    label: 'Por favor, seleccione su país',
    type: 'select',
    options: countryOptions,
    condition: (values: Values) => values.IsChilean !== true,
  },
  {
    name: 'Commune',
    placeholder: 'Por favor, seleccione su comuna',
    label: 'Por favor, seleccione su comuna',
    type: 'select',
    options: communeOptions,
    condition: (values: Values) => values.IsChilean === true,
  },
  {
    name: 'Passport',
    placeholder: 'Ej: P12345678',
    label: 'Pasaporte',
    type: 'text',
    condition: (values: Values) => values.IsChilean !== true,
  },
  {
    name: 'RUT',
    placeholder: 'Ej: 12345678-K',
    label: 'RUT Personal',
    type: 'text',
    condition: (values: Values) => values.IsChilean === true,
    formatter: utils.rut.formatRut,
  },
  {
    name: 'Day',
    placeholder: '12',
    label: '',
    type: 'select',
    options: dayOptions(),
  },
  {
    name: 'Month',
    placeholder: 'Enero',
    label: '',
    type: 'select',
    options: monthOptions,
  },
  {
    name: 'Year',
    placeholder: '1995',
    label: '',
    type: 'select',
    options: yearOptions(),
  },
  {
    name: 'PhoneNumber',
    placeholder: 'Ej: 56 9 12345678',
    label: 'Por favor, ingrese su número de teléfono',
    type: 'text',
    parser: utils.parser.removeNonPhoneNumber,
  },
  {
    name: 'Gender',
    placeholder: 'Selecciona tu sexo',
    label: 'Seleccione su sexo',
    type: 'radio',
    options: GenderOptions,
    extraProps: { columns: 3 },
  },
  {
    name: 'JobTitle',
    placeholder: 'Seleccione su rol en la empresa',
    label: 'Seleccione su rol en la empresa',
    type: 'select',
    options: JobTitleOptions,
  },
  {
    name: 'CompanyName',
    placeholder: 'Ej: Clínica Reñaca',
    label: 'Nombre de su organización o empresa',
    type: 'text',
    maxLength:15,
  },
  {
    name: 'LengthOfService',
    placeholder: 'Ej: 5',
    label: 'Antigüedad de la empresa (años)',
    type: 'number',
  },
])

export const informationValidationSchema = yup.object().shape({
  IsChilean: yup.boolean(),
  Country: yup.string()
    .when('IsChilean', {
      is: false,
      then: yup.string().required(messages.required),
      otherwise: yup.string().notRequired(),
    }),
  Commune: yup.string()
    .when('IsChilean', {
      is: true,
      then: yup.string().required(messages.required),
      otherwise: yup.string().notRequired(),
    }),
  LengthOfService: yup.number()
    .typeError(messages.required)
    .required(messages.required),
  Day: yup.number()
    .required(messages.required),
  Month: yup.number()
    .required(messages.required),
  Year: yup.number()
    .required(messages.required),
  Gender: yup.string()
    .required(messages.required),
  JobTitle: yup.string()
    .required(messages.required),
  CompanyName: yup.string()
    .required(messages.required),
  Passport: yup.string()
    .when('IsChilean', {
      is: false,
      then: yup.string().required(messages.required),
      otherwise: yup.string().notRequired(),
    }),
  RUT: yup.string()
    .when('IsChilean', {
      is: true,
      then: yup.string().required(messages.required).test('rut', messages.rut, utils.rut.validateRut),
      otherwise: yup.string().notRequired(),
    }),
  PhoneNumber: yup.string()
    .required(messages.required),
})
